module.exports = __webpack_public_path__ + "static/media/Logo-Horizontal-fondo-transparente.428f0ca9.png";